<template>
  <basic-container>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item label="中奖时间" prop="daterange">
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="奖品名称">
          <el-input placeholder="输入奖品名称或ID" v-model.trim="query.prize" clearable />
        </el-form-item>
        <el-form-item label="用户">
          <el-input placeholder="输入用户手机号或 ID" v-model.trim="query.user" clearable />
        </el-form-item>
        <el-form-item label="关联活动">
          <el-input placeholder="输入活动名称或 ID" v-model.trim="query.event" clearable />
        </el-form-item>
        <el-form-item label="领取情况" prop="status">
          <el-select v-model="query.isGet" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" :loading="loading"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="reset" :loading="loading"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <yd-table
      :loading="loading"
      :data="records"
      border
      size="mini"
      :pagination="pagination"
      @onChange="onTableChange"
    >
      <el-table-column label="中奖ID" prop="id" align="center" width="100" />
      <el-table-column label="用户信息" align="center" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.userId }}</div>
          <div>{{ scope.row.userPhone }}</div>
        </template>
      </el-table-column>
      <el-table-column label="奖品名称" prop="prizesName" align="center" min-width="300" />
      <el-table-column label="价值" prop="price" align="center" width="120">
        <template slot-scope="scope"> {{ scope.row.price / 100 }}元 </template>
      </el-table-column>
      <el-table-column label="关联活动" prop="raffleName" align="center" min-width="300" />
      <el-table-column label="中奖时间" prop="prizeDate" align="center" width="300" />
      <el-table-column label="领取情况" prop="isGet" align="center" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.isGet === 1">
            已领取
            <div>{{ scope.row.isGetDate }}</div>
          </div>
          <div v-else>未领取</div>
        </template>
      </el-table-column>
    </yd-table>
  </basic-container>
</template>

<script>
  // import dayjs from 'dayjs'
  import { postRecordPage } from '@/api/marketing/pirze-draw'
  export default {
    name: 'winningRecordTable',
    data() {
      return {
        statusList: [
          { value: 1, label: '已领取' },
          { value: 0, label: '未领取' }
        ],
        query: {},
        daterange: [],
        // 分页
        pagination: {
          current: 1,
          size: 10,
          total: 0,
          type: 1
        },
        records: [],
        loading: false
      }
    },
    computed: {},
    created() {},
    mounted() {
      this.initPage()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.initPage()
      },

      search() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0] + ' 00:00:00'
          endTime = this.daterange[1] + ' 23:59:59'
        }
        this.pagination = {
          current: 1,
          size: 10,
          total: 0,
          type: 1,
          startTime,
          endTime,
          ...this.pagination,
          ...this.query
        }
        this.initPage()
      },

      reset() {
        this.daterange = []
        this.query = {}
        this.pagination = {
          current: 1,
          size: 10,
          total: 0,
          type: 1
        }
        this.initPage()
      },

      async initPage() {
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0]
          endTime = this.daterange[1]
        }
        const params = {
          startTime,
          endTime,
          ...this.pagination,
          ...this.query
        }

        this.loading = true
        const res = await postRecordPage(params)
        const { code, data } = res
        if (code === 0) {
          this.records = data.records
          this.total = data.total
          this.pagination.total = data.total
        }
        this.loading = false
      }
    }
  }
</script>

<style lang="scss" scoped></style>
